import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/copysa.svg"; // Replace with the correct path
import { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";

import { getAuthRules } from "../../services/info/info";
import { useEffect } from "react";
function AuthRules() {
  const [rules, setRules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate(); // Initialize useNavigate

  const handleInfo = async () => {
    try {
      const response = await getAuthRules();
      setRules(response.data);
      setIsLoading(false);
    } catch (err) {}
  };
  useEffect(() => {
    handleInfo();
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#F7F2FB",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        component="header"
        sx={{
          backgroundColor: "#512c63",
          width: "100%",
          padding: "1rem",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "sticky",
          top: 0,
          zIndex: 1000,
          minHeight: "200px",
          overflow: "hidden", // Ensures wave remains visible
        }}
      >
        <img src={Logo} width={225} height={100} alt="copysa logo" />

        {/* Wave SVG Divider */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",

            lineHeight: 0,
            zIndex: 2, // Ensures it stays behind the header content
          }}
        >
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            style={{
              display: "block",
              width: "100%",
              height: "50px", // Slightly larger to overlap
              transform: "rotateY(180deg)",
              marginBottom: "-5px", // Pull up to overlap and hide the line
            }}
          >
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              fill="#F7F2FB"
            />
          </svg>
        </Box>
      </Box>
      {isLoading ? (
        <null /> // Show Spinner if loading
      ) : (
        <Box
          component="main"
          sx={{
            flex: 1,
            display: "flex",
            padding: "2rem",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            zIndex: "2",
          }}
        >
          {rules.map((item, index) => (
            <Typography key={index} sx={{ margin: ".75rem 0" }}>
              <Typography
                variant="h4"
                textAlign="justify"
                sx={{ display: "flex", alignItems: "start", fontWeight: "400" }}
              >
                <CheckCircleIcon
                  sx={{
                    marginRight: "8px",
                    color: "#512c63",
                    fontSize: "22px",
                  }}
                />
                {item.textghavanin}
              </Typography>
            </Typography>
          ))}
          <Button
            variant="contained"
            sx={{
              borderRadius: "15px",
              padding: "15px 20px",
              marginTop: "0.5rem",
            }}
            onClick={() => navigate(-1)}
          >
            {t("Term.Accept")}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default AuthRules;
